// src/context/BrandingContext.tsx
// Provides org branding (name, logo, palette) from App.tsx's useOrgInfo hook.
// Each VPS reads ORG_NAME / ORG_ACC* from its own .env → backend serves it → frontend consumes it.

import React, { createContext, useContext } from 'react';
import type { ThemeColors } from '@/hooks/useOrgInfo';

export interface OrgPalette {
  acc1: string;
  acc2: string;
  acc3: string;
  bg_dark: string;
  bg_light: string;
  text_dark: string;
  text_light: string;
}

export const DEFAULT_PALETTE: OrgPalette = {
  acc1: '#00e5ff',
  acc2: '#7a5cff',
  acc3: '#ff4d8d',
  bg_dark: '#0e1115',
  bg_light: '#f6f7fb',
  text_dark: '#eaf0f7',
  text_light: '#131722',
};

export interface Branding {
  orgName: string;
  orgLogo: string | null;
  /** Foto/avatar del agente IA per-org (Company.ai_agent_photo). null = usar el
   *  avatar por defecto del dashboard. */
  agentPhoto: string | null;
  palette: OrgPalette;
}

const BrandingContext = createContext<Branding>({ orgName: '', orgLogo: null, agentPhoto: null, palette: DEFAULT_PALETTE });

export const BrandingProvider = BrandingContext.Provider;

export const useBranding = () => useContext(BrandingContext);

